import { HttpClient, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../auth/authentication.service';
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalConsignmentService {

  private ENDPOINT_CONSIGNMENT = "/consignments";
  public refreshConsignmentList$: EventEmitter<any>;
   constructor(
      private http: HttpClient,
      private auth: AuthenticationService,
      private router: Router
    ) {
      this.refreshConsignmentList$ = new EventEmitter();
     }



    //**================================== Consignment =========================*/
  
    public getAllConsignment(
      filter: any,
      searchValue: any,
      parameters: any
    ) {
      
       let params = new HttpParams();
      if (filter.status !== "" && filter.status != null) {
        params = params.set("status", filter.status);
      }
      if (filter.isMyPending && filter.isMyPending !== ""){
        params = params.set("isMyPending", filter.isMyPending);
      }
      if (filter.fromDate) {
        params = params.set('fromDate', filter.fromDate);
      }
      if (filter.toDate) {
        params = params.set('toDate', filter.toDate);
      }
      if (searchValue) {
        params = params.set('search', searchValue);
      }
      if (parameters) {
        params = params
          .set("startFrom", parameters.startRow)
          .set("perPage", "25")
          .set("columnName", parameters.sortModel[0].colId)
         
      }
      return this.http
        .get(environment.base_url + this.ENDPOINT_CONSIGNMENT, {
          observe: "response",
          params: params,
        })
        .pipe(
          map((resp: any) => {
            return resp;
          }),
          catchError((error) => {
            return throwError(error);
          })
        );
    }

      public deleteConsignment(id: any) {
        return this.http.delete(environment.base_url +  this.ENDPOINT_CONSIGNMENT + '/' + id, { observe: 'response' }).pipe(map((resp: any) => {
          this.refreshConsignmentList$.emit('Deleted Consignment');
          return resp;
        }
        ), catchError(error => {
          //console.log(error);
          return throwError(error);
        }),);
      }

        /************************************************ Consignment statuses ************************************************************************/
        public getStatuses() {
          return this.http.get(environment.base_url + this.ENDPOINT_CONSIGNMENT + '/status', { observe: "response" })
            .pipe(
              map((resp: any) => {
                return resp;
              }),
              catchError((error) => {
                return throwError(error);
              })
            );
        }
        /************************************************ Consignment => save  ************************************************************************/
       public getConsignmentById(id: any) {
        return this.http.get(environment.base_url + this.ENDPOINT_CONSIGNMENT + '/' + id, { observe: "response" })
          .pipe(
            map((resp: any) => {
              return resp;
            }),
            catchError((error) => {
              return throwError(error);
            })
          );
      }
        /************************************************ Consignment => save  ************************************************************************/
        public saveConsignment(data: any) {
          return this.http.post(environment.base_url + this.ENDPOINT_CONSIGNMENT, data, { observe: 'response' }).pipe(map((resp: any) => {
            //this.refreshConsignmentList$.emit('Saved Consignment');
            return resp;
          }
          ), catchError(error => {
            //console.log(error);
            return throwError(error);
          }),);
        }
        /************************************************ Consignment => update  ************************************************************************/
        public updateConsignment(data: any) {
          return this.http.put(environment.base_url + this.ENDPOINT_CONSIGNMENT, data, { observe: 'response' }).pipe(map((resp: any) => {
            this.refreshConsignmentList$.emit('Updated Consignment');
            return resp;
          }
          ), catchError(error => {
            //console.log(error);
            return throwError(error);
          }),);
        }
  //************************************************ Requisition Approve setup ************************************************************************/
  public ConsignmentApproveSetup() {
    return this.http.get(environment.base_url + '/consignment-approvals', { observe: "response" })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }
//************************************************ setup=> save Requisition Approve ************************************************************************/
   public saveConsignmentApproveSetup(data: any) {
    return this.http.post(environment.base_url + '/consignment-approvals', data, { observe: 'response' }).pipe(map((resp: any) => {
      return resp;
    }
    ), catchError(error => {
      //console.log(error);
      return throwError(error);
    }),);
  }
//************************************************ setup => delete Requisition Approve  ************************************************************************/
   public deleteConsignmentApproveSetup(id: any) {
    return this.http.delete(environment.base_url + '/consignment-approvals/' + id, { observe: 'response' }).pipe(map((resp: any) => {
      this.refreshConsignmentList$.emit('Deleted Consignment Approve Setup');
      return resp;
    }
    ), catchError(error => {
      //console.log(error);
      return throwError(error);
    }),);
  }

   /************************************************ Consignment => update status  ************************************************************************/
   public updateConsignmentStatus(data: any,url:any) {
    return this.http.put(environment.base_url +"/"+url, data, { observe: 'response' }).pipe(map((resp: any) => {
      this.refreshConsignmentList$.emit('Updated Consignment Status');
      return resp;
    }
    ), catchError(error => {
      //console.log(error);
      return throwError(error);
    }),);
  }
 /************************************************ Consignment => Get Approval Congi  ************************************************************************/
 public getApprovalConfig(url:any) {
  return this.http.get(environment.base_url +"/"+url, { observe: 'response' }).pipe(map((resp: any) => {
    return resp;
  }
  ), catchError(error => {
    //console.log(error);
    return throwError(error);
  }),);
}
 /************************************************ Consignment => update Approval Config  ************************************************************************/
 public updateApprovalConfig(data: any,url:any) {
  return this.http.put(environment.base_url +"/"+url, data, { observe: 'response' }).pipe(map((resp: any) => {
    //this.refreshConsignmentList$.emit('Updated Consignment Status');
    return resp;
  }
  ), catchError(error => {
    //console.log(error);
    return throwError(error);
  }),);
}

 updateConsignmentTransfer(id: any, type: any) {
      var params = new HttpParams();
    params = params.set("type", type);
    return this.http.post(environment.base_url +"/consignments/transfer-validate/"+id, null, { observe: 'response', params: params }).pipe(map((resp: any) => {
      this.refreshConsignmentList$.emit('Updated Consignment Transfer');
      return resp;
    }
    ), catchError(error => {
      //console.log(error);
      return throwError(error);
    }),);
  
  }
  /************************************************ Consignment => update  ************************************************************************/
        public updateConsignmentHeader(data: any,url:any) {
          return this.http.put(environment.base_url + url, data, { observe: 'response' }).pipe(map((resp: any) => {
            this.refreshConsignmentList$.emit('Updated Consignment');
            return resp;
          }
          ), catchError(error => {
            //console.log(error);
            return throwError(error);
          }),);
        }
}
